import { useState } from 'react';

import useStateHandler from '@/hooks/useStateHandler';
import AuthService from '@/services/auth.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';
import Text from '@/shared-components/text/components/Text';

// eslint-disable-next-line no-unused-vars
import AuthGoogle from './AuthGoogle';

import './styles/AuthLogin.css';

export default function AuthLogin({ setCurrentPage, close }) {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const { stateHandler } = useStateHandler();

  const loginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 
    setError(null); 

    const { response, data } = await AuthService.login(formData.username, formData.password);
        
    if(response.ok) { 
      AuthService.initUserSession(stateHandler, setLoading, data);
      // if we haven't completed the onboarding we don't close the dialog
      if(data?.user_session?.user_flags?.onboarding_completed) {
        close();
      }
    } else if([400, 404].includes(response.status)) {
      setLoading(false);
      setError({ element: data.error_data.element, error_code: data.error_type });
    }
  };

  const onFieldChange = (element, property) => {
    setFormData({ ...formData, [property]: element.target.value });
    setError(null);
  };

  return (
    <>
      <div className="auth-login_header-container">
        <p className="auth-login_header-text">Welcome back! Log into your account below.</p>
      </div>
      <form onSubmit={loginSubmit} className="auth-login__form" >
        <PublicFormInput error={error} placeholder="Username or email" value={formData.username} element="user_email" margin onChange={e => onFieldChange(e, "username")}/>
        <PublicFormInput error={error} placeholder="Password" value={formData.password} element="user_password" type="password" margin onChange={e => onFieldChange(e, "password")}/>
        <Text className="auth-login__forgot-password element-non-selectable" onClick={()=>setCurrentPage("forgot")} small>Forgot your password?</Text>

        <ContinueButton loading={loading} turnOff={error || !formData.username || !formData.password}> 
                    Continue 
        </ContinueButton> 
      </form>

      {/* <AuthGoogle className='auth-login__google-button' close={close}/> */}
    </>
  );
}
